import { render, staticRenderFns } from "./AgentHistory.vue?vue&type=template&id=6ac83152&"
import script from "./AgentHistory.vue?vue&type=script&lang=js&"
export * from "./AgentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports